import Image from "./Image";
import React, { useState, useEffect } from 'react';

const timeout = 10*1000;
let timeId = 0;
const PageLoader = function (props) {
    const [loadingTimeout, setLoadingTimeout] = useState(timeout),
        loaderMessage = props.data.loaderMessage ? props.data.loaderMessage : "Patientez...",
        timeoutMessage = props.data.timeoutMessage ? props.data.timeoutMessage : "La réponse est lente, vérifiez la disponibilité du serveur !"
    ;
    let element = (
        <>
            <Image data={props.hasOwnProperty("data") && props.data.hasOwnProperty("image") ? props.data.image : null} />
            <br/>
            <strong>
                <span className="text-loading text-loading-black">{loaderMessage}</span>
            </strong>
        </>
    );
    useEffect(() => {
        if(loadingTimeout === timeout){
            timeId = setTimeout(() => {
                if(props.data.onPageLoaderTimeout){
                    props.data.onPageLoaderTimeout(true);
                }
                setLoadingTimeout(0);
            }, timeout);
        }
        return () => {clearTimeout(timeId);}
    }, [loadingTimeout, props.data]);

    if(loadingTimeout === 0){
        clearTimeout(timeId);
        element = (<h1>{timeoutMessage}</h1>);
    }
    return (
        <div className="loading-page" style={{textAlign: "center"}}>
            {element}
        </div>
    );
}

export default PageLoader;